import React from 'react';

import SubscriptionForm from "./Subscription/Form";
import GrowBundleForm from "./GrowBundle/Form";
import {injectStripe} from "react-stripe-elements";

function MainForm(props) {
  return (
    <React.Fragment>
      <SubscriptionForm key="subscription_form" {...props} />
      <GrowBundleForm key="grow_bundle_form" {...props}  />
    </React.Fragment>
  );
}

export default injectStripe(MainForm);



// WEBPACK FOOTER //
// ./app/javascript/components/subscription_plan/components/MainForm.js